module.exports = __webpack_public_path__ + "src/assets/img/page8/ed7d23d99e73ac26178deb389b7c635b.jpg";